import { request } from '@/plugins/http';

/**
 * 首页车辆信息列表
 * @param params
 * @returns {AxiosPromise}
 */
const getVehicleList = params => request('/vehicle/getVehicleList', params);

/**
 * 首页vin列表
 * @param params
 * @returns {AxiosPromise}
 */
const getVinList = params => request('/diagnose/getVinList', params);

/**
 * websocket
 * @param params
 * @returns {AxiosPromise}
 */
const websocket = params => request(`/websocket/${params}`);

/**
 * websocket
 * @param params
 * @returns {AxiosPromise}
 */
const downDiagnose = params => request('/diagnose/downDiagnose',params);

export {
    getVehicleList,getVinList,websocket,downDiagnose
};
